export const retryAuthPromise = (fn, ms=500, maxRetries=10) => new Promise((resolve, reject) => {
  var retries = 0;
  fn()
    .then(resolve)
    .catch((error) => {
      // if 401, user is unauthorized
      if (error.request.status === 401) {
        setTimeout(() => {
          retries += 1
          if (retries === maxRetries) {
            return reject('maximum retries exceeded')
          }
          retry(fn, ms).then(resolve)
        }, ms)
      }
    })
})

export const parseJwt = (token) => {
  if (!token) {
    return null;
  }

  const base64Url = token.split('.')[1] ?? '';
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('')
    .map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
    .join(''));

  return JSON.parse(jsonPayload);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js